module.exports = __webpack_public_path__ + "img/visa.9df29d10.svg";